module.exports = __webpack_public_path__ + "img/carouselBg1.7c3b981f.png";